import { render, staticRenderFns } from "./depamentDialogTwo.vue?vue&type=template&id=3cedabbf&scoped=true&"
import script from "./depamentDialogTwo.vue?vue&type=script&lang=js&"
export * from "./depamentDialogTwo.vue?vue&type=script&lang=js&"
import style0 from "./depamentDialogTwo.vue?vue&type=style&index=0&id=3cedabbf&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3cedabbf",
  null
  
)

export default component.exports